import { Box, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import { ButtonV1 } from "components";
import SectionHeader from "./SectionHeader";
import TruckLoader from "./TruckLoader";

const DeliveryInstructionAndOther = ({
  onCancel,
  onSubmit,
  isSubmitting,
  isSuccessAnim = false,
}) => {
  const theme = useTheme();
  return (
    <Box mb={3}>
      <SectionHeader stepNumber={3} title="Delivery Actions" />

      <Box
        sx={{
          border: `1px solid ${theme.palette.grey["400"]}`,
          borderRadius: 2,
          padding: 3,
          mb: 3,
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <TruckLoader
            isSubmitting={isSubmitting}
            isSuccessAnim={isSuccessAnim}
          />

          <Box display="flex" alignItems="center" gap={1.5} flexShrink={0} mt={5}>
            <ButtonV1
              title="Cancel"
              variant="outlined"
              onClick={onCancel}
              disabled={isSubmitting || isSuccessAnim}
            />

            <ButtonV1
              title="Submit"
              onClick={onSubmit}
              loader={isSubmitting}
              disabled={isSuccessAnim}
              variant="contained"
              color="primary"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DeliveryInstructionAndOther.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  isSuccessAnim: PropTypes.bool,
};

export default DeliveryInstructionAndOther;
